import { environmentHttpClient as httpClient } from "client/Api/httpClient";
import { AutotaskConnectionIdentifierViewModel } from "client/Api/Apps/EditApp/saveApp";

interface TicketListItem {
	id: number;
	title: string;
	status: string;
	creationDate: string;
	portalUrl: string;
}

enum TicketsLoadStatus {
	NoError = 0,
	UnknownError = 1,
	NotConfigured = 2
}

interface TicketListWithConnection {
	status: TicketsLoadStatus;
	items: LazyLoadPageResult<TicketListItem>;
	createNewTicketUrl: string;
	connection: AutotaskConnectionIdentifierViewModel;
}

function listTickets(connections: AutotaskConnectionIdentifierViewModel[]): Promise<TicketListWithConnection[]> {
	return httpClient.post<TicketListWithConnection[]>(
		"Workspace/LiveInformation/Autotask",
		connections
	);
}

export {
	listTickets,
	type TicketListItem,
	type TicketListWithConnection,
	TicketsLoadStatus
};
